import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { ScrollArea } from '@/components/ui/scroll-area';

export default function AgentFormDialog({
  open,
  onOpenChange,
  onSubmit,
  consultants,
  initialData,
  title,
  submitLabel = 'Save'
}) {
  const [form, setForm] = useState({ name: '', email: '', phone: '', notes: '', assigned: [] });

  useEffect(() => {
    if (open) {
      setForm({
        name: initialData?.name || '',
        email: initialData?.email || '',
        phone: initialData?.phone || '',
        notes: initialData?.notes || '',
        assigned: initialData?.assigned || []
      });
    }
  }, [open, initialData]);

  const toggleConsultant = (consultantId) => {
    setForm((prev) => {
      const exists = prev.assigned.includes(consultantId);
      return {
        ...prev,
        assigned: exists ? prev.assigned.filter((id) => id !== consultantId) : [...prev.assigned, consultantId]
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <form onSubmit={handleSubmit} className="space-y-4">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          <div className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="hr-name">Name</Label>
              <Input
                id="hr-name"
                required
                value={form.name}
                onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="hr-email">Email</Label>
              <Input
                id="hr-email"
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="hr-phone">Phone</Label>
              <Input
                id="hr-phone"
                value={form.phone}
                onChange={(e) => setForm((prev) => ({ ...prev, phone: e.target.value }))}
              />
            </div>
            <div className="grid gap-2">
              <Label>Consultant assignments</Label>
              <ScrollArea className="h-48 border rounded-md p-2">
                <div className="space-y-3">
                  {consultants.map((consultant) => {
                    const disabled = consultant.locked && !form.assigned.includes(consultant.id);
                    return (
                      <label key={consultant.id} className="flex items-start gap-2 text-sm">
                        <Checkbox
                          checked={form.assigned.includes(consultant.id)}
                          onCheckedChange={() => toggleConsultant(consultant.id)}
                          disabled={disabled}
                        />
                        <div>
                          <div className="font-medium">{consultant.name}</div>
                          <div className="text-muted-foreground">
                            {disabled ? `Assigned to ${consultant.locked}` : consultant.email || 'No email'}
                          </div>
                        </div>
                      </label>
                    );
                  })}
                  {consultants.length === 0 && (
                    <p className="text-muted-foreground text-sm">No consultants available</p>
                  )}
                </div>
              </ScrollArea>
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit">{submitLabel}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
